import { useState } from 'react';

import { CancelSaveButtons } from '@components/cancel-save-buttons';
import { Card } from '@components/card';
import { Slider } from '@components/slider';

import { useUpdateCompanyInfo, useUpdateCareerImage } from 'api/companies/hooks';
import { ImageInput } from 'components/image-input';
import { SettingsSection } from 'components/settings-section';
import { useStore } from 'models/Provider';
import { Company } from 'types/companies';

type CareerLogoProps = {
  companyInfo: Company;
};

export const CareerLogo = ({ companyInfo }: CareerLogoProps) => {
  const { t } = useStore();
  const [heightDraft, setHeightDraft] = useState(companyInfo.logoHeight);
  const submitLogo = useUpdateCareerImage();
  const submitHeight = useUpdateCompanyInfo({
    successMessage: t('company.settings.career.update.logoheight.success'),
    errorMessage: t('company.settings.career.update.logoheight.error'),
  });

  const isHeightDirty = heightDraft !== companyInfo.logoHeight;

  return (
    <>
      <SettingsSection
        title={t('company.settings.career.theme.logo.title')}
        description={t('company.settings.career.theme.logo.description')}
        hasSeparator
      >
        <ImageInput
          key={companyInfo.logo}
          url={companyInfo.logo}
          maxHeight={heightDraft}
          onSave={(logo) => submitLogo.mutate({ logo })}
        />
      </SettingsSection>
      <SettingsSection
        title={t('company.settings.career.theme.logosize.title')}
        description={t('company.settings.career.theme.logosize.description')}
        hasSeparator
      >
        <Card variant="transparent" spaceY={6} spaceX={8}>
          <Slider
            label={t('company.settings.career.theme.logosize.label')}
            minValue={24}
            maxValue={48}
            onChange={(value) => setHeightDraft(value)}
            value={heightDraft}
          />
          <CancelSaveButtons
            isOpen={isHeightDirty}
            onCancel={() => setHeightDraft(companyInfo.logoHeight)}
            onSave={() => submitHeight.mutate({ logoHeight: heightDraft })}
            isDisabled={submitLogo.isLoading}
          />
        </Card>
      </SettingsSection>
    </>
  );
};
